class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.duration = parseInt(this.dataset.duration);
    this.initTimer();
    this.updateTimer();
    this.playTimer();
  }

  initTimer() {
    this.innerHTML = "";

    this.minutesSpan = document.createElement("span");
    this.secondsSpan = document.createElement("span");
    const separator = document.createTextNode(":");

    this.append(this.minutesSpan, separator, this.secondsSpan);
  }

  updateTimer() {
    let time = parseInt(this.dataset.duration);
    if (time === 0) time = 90;

    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    this.minutesSpan.innerHTML = this.formatNumber(minutes);
    this.secondsSpan.innerHTML = this.formatNumber(seconds);

    this.dataset.duration = time - 1;
  }

  playTimer() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.playInterval = setInterval(() => {
        this.updateTimer();
      }, 1000);
    }
  }

  pauseTimer() {
    clearInterval(this.playInterval);
    this.isPlaying = false;
  }

  formatNumber(number) {
    return number.toString().length === 1 ? "0" + number : number;
  }
}

customElements.define("countdown-timer", CountdownTimer);
